import React from "react";
import { Table, Button } from "reactstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import cronParser from "cron-parser";

const TableShop = (props) => {
    const getScheduleTime = (schedule) => {
        try {
            return moment(
                cronParser.parseExpression(schedule).prev().toString()
            ).format("h:mm a");
        } catch (err) {
            return "-";
        }
    };

    const styles = {
        tableHead: {
            paddingTop: "2vh",
            fontSize: "1em",
            textTransform: "capitalize",
            color: "#2c2a2a",
            borderTop: "none",
        },
    };

    return (
        <Table className="align-items-center" hover responsive>
            <thead>
                <tr>
                    {props.header?.map((item, index) => (
                        <th style={styles.tableHead} key={index}>
                            {item}
                        </th>
                    ))}
                    <th style={styles.tableHead}>Options</th>
                </tr>
            </thead>
            <tbody>
                {props.searchedData?.map((item, index) => (
                    <tr style={{ color: "#6C6C6C" }} key={index}>
                        <td>{item.location}</td>
                        <td>{item.Company?.name || "-"}</td>
                        <td>{item.pos_type}</td>
                        <td>{getScheduleTime(item.schedule)}</td>
                        <td>
                            <label className="custom-toggle">
                                <input
                                    checked={item.is_enabled}
                                    disabled={props.showArchived}
                                    type="checkbox"
                                    onChange={() =>
                                        props.changeEnabled(
                                            item._id,
                                            item.is_enabled === true
                                                ? false
                                                : true
                                        )
                                    }
                                />
                                <span className="custom-toggle-slider rounded-circle" />
                            </label>
                        </td>
                        {props.userRole === "admin" && (
                            <td>
                                <Link
                                    to={`/admin/shops/${item._id}/logs`}
                                    style={{
                                        textDecoration: "underline",
                                        color: "#6C6C6C",
                                    }}
                                    className="pr-4"
                                >
                                    <span>VIEW LOGS</span>
                                </Link>
                                {props.showArchived ? (
                                    <Button
                                        color="secondary"
                                        outline
                                        type="button"
                                        onClick={() => {
                                            props.unarchiveShop(item._id);
                                        }}
                                    >
                                        UNARCHIVE
                                    </Button>
                                ) : (
                                    <>
                                        <Link to={`/admin/shops/${item._id}/edit`}>
                                            <Button
                                                color="secondary"
                                                outline
                                                type="button"
                                            >
                                                EDIT
                                            </Button>
                                        </Link>
                                        <Button
                                            color="secondary"
                                            outline
                                            type="button"
                                            onClick={() => {
                                                props.runPosScript(item._id);
                                            }}
                                        >
                                            RUN POS SCRIPT
                                        </Button>
                                        <Button
                                            color="secondary"
                                            outline
                                            type="button"
                                            onClick={() => {
                                                props.runDateScript(item._id);
                                            }}
                                        >
                                            RUN SCRIPT BY DATE
                                        </Button>
                                        <Button
                                            color="danger"
                                            outline
                                            type="button"
                                            onClick={() => {
                                                props.archiveShop(item._id);
                                            }}
                                        >
                                            ARCHIVE
                                        </Button>
                                    </>
                                )}
                            </td>
                        )}
                        {props.userRole === "company" && (
                            <td>
                                <Link
                                    to={`/company/shops/${item._id}/logs`}
                                    style={{
                                        textDecoration: "underline",
                                        color: "#6C6C6C",
                                    }}
                                    className="pr-4"
                                >
                                    <Button
                                        color="secondary"
                                        outline
                                        type="button"
                                    >
                                        VIEW LOGS
                                    </Button>
                                </Link>
                                <Button
                                    color="secondary"
                                    outline
                                    type="button"
                                    onClick={() => {
                                        props.runPosScript(item._id);
                                    }}
                                >
                                    RUN POS SCRIPT
                                </Button>
                                <Button
                                    color="secondary"
                                    outline
                                    type="button"
                                    onClick={() => {
                                        props.runDateScript(item._id);
                                    }}
                                >
                                    RUN SCRIPT BY DATE
                                </Button>
                            </td>
                        )}
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default TableShop;
